module.exports = __webpack_public_path__ + "static/media/multimedia_game_sound_synth_tone_bold_fail_52993.170b7bf2.wav";